import { assistantsRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN];

const assistantsRouteMetadata: IRouteMetadataObj<typeof assistantsRoutesObj> = {
  create: {
    title: "users.assistant.create.title",
    description: "users.assistant.create.description",
    lazy: () => import("@/pages/userManagement/assistants/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "users.assistant.edit.title",
    description: "users.assistant.edit.description",
    lazy: () => import("@/pages/userManagement/assistants/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
};

export const assistantsRoutes = createRoute<typeof assistantsRoutesObj>(
  assistantsRoutesObj,
  assistantsRouteMetadata,
);
